import { useMutation } from "@apollo/client";
import { Database } from "@nozbe/watermelondb";
import { withDatabase } from "@nozbe/watermelondb/DatabaseProvider";
import { useDatabase } from "@nozbe/watermelondb/hooks";
import {
  withObservables,
  ExtractedObservables,
} from "@nozbe/watermelondb/react";
import { useWithAppState } from "@towersystems/roam-common-native";
import { Success } from "@towersystems/roam-common/lib/generated-types";
import { compose } from "recompose";
import Location from "../../../../utilities/data/model/Location";
import {
  EXPORT_PENDING_STOCKTAKE_COUNT_ITEMS,
  EXPORT_STOCK_COUNT_ITEMS,
} from "../../../../utilities/stock-count";
import { StockCountContext } from "../../../../utilities/stock-count/context";

export interface StockCountProviderProps
  extends ExtractedObservables<ReturnType<typeof getObservables>> {
  children?: React.ReactNode;
}

const getObservables = ({ database }: { database: Database }) => {
  return {
    locations: database.get<Location>("locations").query().observe(),
  };
};

function StockCountProviderInner({
  locations,
  children,
}: StockCountProviderProps) {
  const {
    appState: { locationId: activeLocationId },
  } = useWithAppState();

  const database = useDatabase();

  const [exportPendingStocktakeCountItems] = useMutation<{
    exportPendingStocktakeCountItems: Success;
  }>(EXPORT_PENDING_STOCKTAKE_COUNT_ITEMS);

  const [exportStockCountItems] = useMutation<{
    exportStockCountItems: Success;
  }>(EXPORT_STOCK_COUNT_ITEMS);

  const defaultLocationId = activeLocationId || locations[0]?.id;

  async function handleExportStockCount(stockCountId: string) {
    await exportPendingStocktakeCountItems({
      variables: { stockCountId },
    }).then((res) => {
      if (!res.data) {
        throw new Error(
          "No data returned from exportPendingStocktakeCountItems mutation"
        );
      }

      if (res.data.exportPendingStocktakeCountItems.success) {
      } else {
        // TODO: Handle error
        console.error("Failed to export pending stock count items");
      }
    });
  }

  async function handleExportStockCountItems(stocktakeCountIds: string[]) {
    await exportStockCountItems({
      variables: { stocktakeCountIds },
    }).then(async (res) => {
      if (!res.data) {
        throw new Error(
          "No data returned from handleExportStockCountItems mutation"
        );
      }

      if (res.data.exportStockCountItems.success) {
        // do nothing
      } else {
        console.error("Failed to export stock count items");
      }
    });
  }

  return (
    <StockCountContext.Provider
      value={{
        locations,
        defaultLocationId,
        handleExportStockCount,
        handleExportStockCountItems,
      }}
    >
      {children}
    </StockCountContext.Provider>
  );
}

const enhance = withObservables([], getObservables);

export const StockCountProvider = compose(
  withDatabase,
  enhance
  //@ts-ignore
)(StockCountProviderInner);
